export default __webpack_public_path__ + "static/media/condense.b7cecc32.svg";